<template>
    <div>
        <page-header
                v-if="!this.$hasPermission('Client_create')"
                copyLink="ACTIONS.COPY_LINK_PUBLIC_CLIENT"
                pageTitle="CLIENTS.INDEX_TITLE"
                :haveSearch="true"
                @searching="search($event)"/>
        <page-header
                v-if="this.$hasPermission('Client_create')"
                pageTitle="CLIENTS.INDEX_TITLE"
                has-slot>
            <template #container>
                <div class="d-flex flex-row ">
                    <div class="card mt-2 mr-2 card-hover-scale dashboard-summary-card" @click="$router.push('/clientes/dashboard')"
                          title="Dashboard"
                          v-if="this.peopleQtd && !widthMd(1000)"
                    >
                        <div class="p-2 pl-3 pr-3 d-flex flex-row justify-content-between">
                            <div class="align-self-center">
                                <span><h5>{{ this.peopleQtd }}</h5> </span>
                                <p style="font-size: smaller; font-weight: 600">{{ this.t('DASHBOARD.PEOPLES') }}</p>
                            </div>
                            <div class="d-flex flex-row-reverse">
                                <svg class="apexcharts-svg" transform="translate(0, 0)" width="170" height="50">
                                    <g class="apexcharts-inner apexcharts-graphical" transform="translate(30, -5)">
                                        <defs>
                                            <filter id="SvgjsFilter1075" filterUnits="userSpaceOnUse" width="100%"
                                                    height="150%">
                                                <feOffset id="SvgjsFeOffset1068" result="offset" in="SourceGraphic"
                                                          dx="1"
                                                          dy="1"></feOffset>
                                                <feGaussianBlur id="SvgjsFeGaussianBlur1069" result="blur" in="offset"
                                                                stdDeviation="2"></feGaussianBlur>
                                                <feFlood id="SvgjsFeFlood1070" result="flood" in="SourceGraphic"
                                                         flood-color="#000000" flood-opacity="0.5"></feFlood>
                                                <feComposite id="SvgjsFeComposite1071" result="shadow" in="flood"
                                                             in2="blur"
                                                             operator="in"></feComposite>
                                                <feMerge id="SvgjsFeMerge1072" result="SvgjsFeMerge1072"
                                                         in="SourceGraphic">
                                                    <feMergeNode id="SvgjsFeMergeNode1073" result="SvgjsFeMergeNode1073"
                                                                 in="shadow"></feMergeNode>
                                                    <feMergeNode id="SvgjsFeMergeNode1074" result="SvgjsFeMergeNode1074"
                                                                 in="SourceGraphic"></feMergeNode>
                                                </feMerge>
                                            </filter>
                                        </defs>
                                        <g>
                                            <g>
                                                <path d="M 0 44C 5.1722222222222225 44 9.605555555555556 43 14.777777777777779 43C 19.950000000000003 43 24.383333333333333 49 29.555555555555557 49C 34.72777777777778 49 39.16111111111111 26.5 44.333333333333336 26.5C 49.50555555555556 26.5 53.93888888888889 34 59.111111111111114 34C 64.28333333333333 34 68.71666666666667 28 73.8888888888889 28C 79.06111111111112 28 83.49444444444445 43 88.66666666666667 43C 93.8388888888889 43 98.27222222222224 22.5 103.44444444444446 22.5C 108.61666666666667 22.5 113.05000000000001 29.5 118.22222222222223 29.5C 123.39444444444445 29.5 127.82777777777778 15.5 133 15.5"
                                                      fill="none" fill-opacity="1" stroke="rgba(255,255,255,0.85)"
                                                      stroke-opacity="1" stroke-linecap="butt" stroke-width="3"
                                                      stroke-dasharray="0" class="apexcharts-line" index="0"
                                                      clip-path="url(#gridRectMaskssa0k9x6)"
                                                      filter="url(#SvgjsFilter1075)"
                                                      pathTo="M 0 44C 5.1722222222222225 44 9.605555555555556 43 14.777777777777779 43C 19.950000000000003 43 24.383333333333333 49 29.555555555555557 49C 34.72777777777778 49 39.16111111111111 26.5 44.333333333333336 26.5C 49.50555555555556 26.5 53.93888888888889 34 59.111111111111114 34C 64.28333333333333 34 68.71666666666667 28 73.8888888888889 28C 79.06111111111112 28 83.49444444444445 43 88.66666666666667 43C 93.8388888888889 43 98.27222222222224 22.5 103.44444444444446 22.5C 108.61666666666667 22.5 113.05000000000001 29.5 118.22222222222223 29.5C 123.39444444444445 29.5 127.82777777777778 15.5 133 15.5"
                                                      pathFrom="M 0 50 L 0 50 L 14.777777777777779 50 L 29.555555555555557 50 L 44.333333333333336 50 L 59.111111111111114 50 L 73.8888888888889 50 L 88.66666666666667 50 L 103.44444444444446 50 L 118.22222222222223 50 L 133 50"
                                                      fill-rule="evenodd"></path>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class=" mt-2  d-flex flex-row pl-2" style=" border-radius: 15px;"
                         :class="!widthMd(1000) && this.$hasPermission('group_adm') && this.peopleQtd ? 'card pr-3' : ''">
                        <div class="align-self-center mr-2">
                            <div class="custom-search" v-if="!widthMd(500)">
                                <input type="text" class="search-query" v-model="searchI" placeholder="Pesquisar"
                                       @keypress="emitWithEnter($event)">
                                <i class="icon-search1" @click="search(searchI)"></i>
                            </div>
                        </div>
                        <div class="align-self-center mr-2">
                            <a class="btn btn-primary" @click="setModalFilter"
                               id="filter" data-toggle="modal" data-target="#customModalTwo">
                                 Filtros
                            </a>
                        </div>
                        <div class="align-self-center mr-2">
                            <a class="btn btn-primary" @click="setModalCopyLink" id="copy">
                                <i class="icon-copy" v-if="!widthMd(1300)"></i> {{widthMd(1300) ? 'Link': t('ACTIONS.COPY_LINK_PUBLIC_CLIENT')}}
                            </a>
                        </div>
                        <div class="align-self-center mr-2">
                            <a class="btn btn-custom bg-btn" data-toggle="modal" data-target="#customModalTwo"
                               @click="setRegisterModal('juridical')" id="new" data-cy="btn-new-page-header">
                                <i class="icon-circle-with-plus"></i>
                                {{ widthMd(1300) ? 'PJ' : 'Nova Pessoa Jurídica' }}
                            </a>
                        </div>
                        <div class="align-self-center mr-2">
                            <div class="btn btn-custom bg-btn" data-toggle="modal" data-target="#customModalTwo"
                                 @click="setRegisterModal('phisical')" id="secondbtn">
                                <i class="icon-circle-with-plus"/>{{ widthMd(1300) ? 'PF' : 'Nova Pessoa Física' }}
                            </div>
                        </div>
                        <div class="align-self-center " v-if="!widthMd(576) && this.$hasPermission('group_adm')">
                            <div class="text-right">
                                <button data-cy="lot_index_dropdown" class="btn btn-custom bg-btn no-border"
                                        type="button"
                                        id="import-buttom"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="icon-menu"/>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right dropdown-black dropdown-lot w-auto pr-2"
                                     id="dropdown-import">
                                    <div class="dropdown-item bg-hover-black"
                                         @click="uploadFile = true; isAnex = false">
                                        <div class="row item-custom2 ml-1 text-white ">
                                            <i class="icon-folder_open mr-2 font-15"/>{{ t('CLIENTS.IMPORT_FILE') }}
                                            XLSX
                                        </div>
                                    </div>
                                    <div class="dropdown-item bg-hover-black">
                                        <a class="row item-custom2 ml-1 text-white" data-toggle="modal"
                                           data-target="#customModalTwo" @click="exportClient()">
                                            <i class="icon-file mr-2 font-15"/>{{ t('CLIENTS.EXPORT_FILE_CLIENT') }}
                                            XLSX
                                        </a>
                                    </div>
                                    <div class="dropdown-item bg-hover-black">
                                        <a class="row item-custom2 ml-1 text-white"
                                           href="Modelo para Importação Pessoas.xlsx"
                                           download>
                                            <i class="icon-arrow-with-circle-down mr-2 font-15"/>{{
                                                t('GENERAL.MSG.DOWNLOAD_FILE_EXEMPLE')
                                            }}
                                        </a>
                                    </div>
                                    <div class="dropdown-item bg-hover-black" v-if="this.peopleQtd">
                                        <a class="row item-custom2 ml-1 text-white"
                                           @click="$router.push('/clientes/dashboard')">
                                            <i class="icon-show_chart mr-2 font-15"/>{{
                                                t('GENERAL.MSG.DASHBOARD_PEOPLE')
                                            }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </page-header>
        <list-component
                :items="items.data"
                @open="open($event)"
                :haveDetails="true"
                v-if="items && !items.validations">
            <template v-slot:principal-info="{items}">
                <div
                        class="list-primary hide-text"><i
                        title="Cadastro incompleto"> {{
                        items.iten.incomplete_register ? '⚠️' : ''
                    }}</i>&nbsp; &nbsp;{{ items.iten?.name ? items.iten?.name : items.iten.corporate_name }}
                </div>
            </template>
            <template v-slot:dropdown-options="items">
                <div
                        id="teste"
                        class="dropdown-item pointer text-white"
                        data-target="#customModalTwo"
                        data-toggle="modal"
                        @click="setEditModal(items.iten.id)"
                        v-if="this.$hasPermission('Client_update')"
                        data-cy="edit-client">
                    <i
                            class="icon-edit mr-2 font-15"/>{{ t('ACTIONS.EDIT') }}
                </div>
                <div class="dropdown-item pointer text-white"
                     @click="showAlert(items.iten.id)"
                     v-if="this.$hasPermission('Client_delete')"
                     data-cy="destroy-client">
                    <i
                            class="icon-delete mr-2 font-15"/>{{ t('ACTIONS.DELETE') }}
                </div>
                <div class="dropdown-item pointer text-white" data-target="#customModalTwo" data-toggle="modal"
                     @click="setViewModal(items.iten.id)"
                     v-if="this.$hasPermission('Client_show')">
                    <i
                            class="icon-eye1 mr-2 font-15"/>{{ t('ACTIONS.VIEW') }}
                </div>
                <div class="dropdown-item pointer text-white"
                     @click="printClientPdf(items.iten)" v-if="this.$hasPermission('Client_show')">
                    <i
                            class="icon-file mr-2 font-15"/>{{ t('ACTIONS.PRINT_PDF_CLIENT') }}
                </div>
            </template>
            <template
                    v-slot:details-itens="items">
                <div
                        class="form-group mt-2 text-center"
                        v-if="!widthPhone()">
                    <label
                            for="name"
                            class="mb-2">{{ t('GENERAL.PHONE') }}: </label>
                    <p
                            class="color-grey mt-2">{{ phoneNumber(items.iten) }}</p>
                </div>
                <div class="form-group mt-2 text-center" v-if="!widthPhone()">
                    <label for="name" class="mb-2">{{ t('COMPANIES.TAXPAYER') }}: </label>
                    <p class="color-grey mt-2">{{ items.iten.taxpayer }}</p>
                </div>
                <div class="form-group mt-2 text-center" v-if="!widthPhone()">
                    <label for="name" class="mb-2">{{ t('GENERAL.EMAIL') }}: </label>
                    <p class="color-grey mt-2">{{ items.iten.email }}</p>
                </div>
                <div class="form-group mt-2 text-center"
                     v-if="!widthPhone() && this.$hasPermission('Client_delete')">
                    <label for="name" class="mb-2">{{ t('GENERAL.ADDED_BY') }}: </label>
                    <p class="color-grey mt-2">{{ items.iten?.realtor?.name }}</p>
                </div>
                <div
                        class="row gutters"
                        v-if="widthPhone()">
                    <div
                            class="col-sm-6 col-6">
                        <div
                                class="form-group mt-2 ml-2 text-left">
                            <label for="name">{{ t('GENERAL.PHONE') }}: </label>
                            <p class="color-grey mt-2">{{ phoneNumberToCell(items.iten) }}</p>
                        </div>
                        <div class="form-group mt-2 ml-2 text-left">
                            <label for="name">{{ t('COMPANIES.TAXPAYER') }}: </label>
                            <p class="color-grey mt-2">{{ items.iten.taxpayer }}</p>
                        </div>
                    </div>
                    <div class="col-sm-6 col-6">
                        <div class="form-group mt-2 ml-2 text-left" v-if="widthPhone()">
                            <label
                                    for="mail">{{ t('GENERAL.EMAIL') }}: </label>
                            <p
                                    id="mail" class="color-grey mt-2">{{ items.iten.email }}</p>
                        </div>
                        <div class="form-group mt-2 ml-2 text-left"
                             v-if="widthPhone() && this.$hasPermission('Client_delete')">
                            <label
                                    for="addBy" class="mb-2">{{ t('GENERAL.ADDED_BY') }}: </label>
                            <p
                                    id="addBy" class="color-grey mt-2">{{ items.iten?.realtor?.name }}</p>
                        </div>
                    </div>
                </div>
            </template>
        </list-component>
        <div
                class="card"
                v-if="items && items.validations">
            <div
                    class="card-header"></div>
            <div
                    class="card-body pt-0">
                <div class="text-center">
                    <h5>{{ t('GENERAL.MSG.NONE_CLIENT_FOUND') }}</h5>
                </div>
            </div>
        </div>
        <div class="row gutters w-100">
            <div class="col-12">
                <pagination-component
                        v-if="items && items.data && items.data[0]"
                        :items="items"
                        :to="'/cliente'"
                        :have-per-page="!widthMd(1000)"
                        :per-page="perPage"
                        :paginate="paginate"
                        @changePage="index(filter, $event)"
                        @changePaginate="changePaginate"></pagination-component>
            </div>
        </div>
        <modal
                :titleModal="modalTitle"
                :modal-x-xl="wichModal !== 4 && wichModal !== 5 && wichModal !== 6"
                :modal-large="wichModal === 4 || wichModal === 5 || wichModal === 6"
                @close="closeModal">
            <template v-slot:title>{{ t(modalTitle) }}</template>
            <create-client
                    @to-update="switchToEdit"
                    v-if="client && wichModal == 1"
                    :clientIndex="client"
                    :addressIndex="address"
                    @update="index()"
                    :is-phisical-index="isPhisical"
            >
            </create-client>
            <view-client
                    v-if="client && wichModal == 2" :clientIndex="client" :addressIndex="address">
            </view-client>
            <div v-if="wichModal == 3">
                <div class="modal-row2 modal-height-max">
                    <div class="modal-body">
                        <form id="formUpload">
                            <div class="row gutters">
                                <div
                                        class="col-12 justify-content-end d-flex mb-3">
                                    <a
                                            class="btn btn-custom bg-btn ml-3"
                                            @click="setFile"
                                            id="new_anex">
                                        <i
                                                class="icon-circle-with-plus"></i> Adicionar
                                    </a>
                                </div>
                            </div>
                            <div class="row gutters"
                                 v-if="documents?.length">
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 row pl-4">
                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 font-bold">
                                        <div class="font-weight-bolder mt-2 ml-4 text-left">{{
                                                this.t('CLIENTS.DOCUMENTS.NAME')
                                            }}
                                        </div>
                                    </div>
                                    <div
                                            class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 font-bold">
                                        <div
                                                class="font-weight-bolder mt-2 ml-3 text-left">{{
                                                this.t('CLIENTS.DOCUMENTS.SIZE')
                                            }}
                                        </div>
                                    </div>
                                    <div
                                            class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 font-bold">
                                        <div class="font-weight-bolder mt-2 ml-4 text-left">
                                            {{ this.t('CLIENTS.DOCUMENTS.ACTIONS') }}
                                        </div>
                                    </div>
                                </div>
                                <div
                                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 row p-2"
                                        v-for="(document, key) in documents"
                                        :key="key"
                                        :class="key != 0 ? 'border-top2': ''">
                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                                        <div class="list-primary  text-left">
                                            {{ document.name }}
                                        </div>
                                    </div>
                                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4">
                                        <div class="list-primary  text-left">
                                            {{ formatSize(document.file_size) }}
                                        </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 row">
                                        <div
                                                class="list-primary pointer text-center"
                                                title="Download">
                                            <i
                                                    class="icon-download pl-3"
                                                    @click="downloadDocument(document)"></i>
                                        </div>
                                        <div class="list-primary pointer text-center"
                                             title="Deletar Anexo">
                                            <i
                                                    class="icon-trash-2 pl-2"
                                                    @click="documentDelete(document.id)"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                    class="card w-100" v-else>
                                <div class="card-header"></div>
                                <div class="card-body pt-0">
                                    <div class="text-center">
                                        <h5>Nenhum Documento Foi Cadastrado</h5>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="modal-footer">
                    <button
                            class="btn btn-secondary"
                            @click="closeModalAnex()">
                        {{ t('ACTIONS.CLOSE') }}
                    </button>
                </div>
            </div>
            <div class="modal-content" v-if="wichModal === 4">
                <div class="modal-body modal-open modal-height-max client-allotment-body">
                    <div class="row gutters">
                        <div class="col-xl-12 col-lglg-12 col-md-12 col-sm-12 col-12">
                            <div class="form-group mb-1">
                                <label for="company" class="client-allotment-search-label">Buscar loteamento</label>
                                <input type="text" name="company" v-model="allotmentModal" id="company"
                                       class="form-control client-allotment-search-input" @keyup="selectAllotmentModal"
                                       placeholder="Digite o nome do loteamento para buscar">
                                <div class="client-allotment-list modal-row2">
                                    <div v-for="allotment in [{id:'nenhum', text:'Nenhum'},...allotments]"
                                         :key="allotment.id" class="client-allotment-list-item">
                                        <button class="btn client-allotment-option-button" @click="copyLink(allotment.id)">
                                            <span class="client-allotment-option-avatar">{{ allotment.text?.charAt(0) }}</span>
                                            <span class="client-allotment-option-name">{{ allotment.text }}</span>
                                            <span class="client-allotment-option-icon icon-keyboard_arrow_right"></span>
                                        </button>
                                    </div>
                                    <div class="client-allotment-empty-state" v-if="!allotments || !allotments.length">
                                        Nenhum loteamento encontrado
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-content" v-if="wichModal === 5">
                <div class="modal-body">
                    <div class="row gutters">
                        <div class="col-6">
                            <div class="form-group">
                                <label for="">{{ t('CLIENTS.FILTER_CREATED_START') }}</label>
                                <input type="date" class="form-control" v-model="filterExport.created_at_start">
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label for="">{{ t('CLIENTS.FILTER_CREATED_END') }}</label>
                                <input type="date" class="form-control" v-model="filterExport.created_at_end">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-primary" @click="sendExport">Exportar</button>
                </div>
            </div>
            <div class="modal-content" v-if="wichModal === 6">
                <div class="modal-body">
                    <div class="row gutters">
                        <div class="col-6">
                            <div class="form-group">
                                <label for="">Nome</label>
                                <input type="text" placeholder="Nome" class="form-control" v-model="filters.name">
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label for="">CPF/CNPJ</label>
                                <input type="text" class="form-control" v-model="filters.taxpayer" placeholder="CPF/CNPJ"
                                       v-mask="['###.###.###-##', 'XX.XXX.XXX/XXXX-##']">
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label for="">E-mail</label>
                                <input type="text" class="form-control" placeholder="E-mail" v-model="filters.email">
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label for="">Loteamento</label>
                                <Select2
                                        :settings="{width: '100%'}"
                                        placeholder="Selecione"
                                        :options="[{id: 'selecione', text: 'Selecione'}, ...allotmentsState]"
                                        v-model="filters.allotment_id"
                                ></Select2>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-primary" @click="filtering" data-dismiss="modal">Filtrar</button>
                    <button class="btn btn-secondary" data-dismiss="modal" @click="clearFilters">Limpar</button>
                </div>
            </div>
        </modal>
        <upload-modal
                :uploadFile="uploadFile"
                @upload="uploadFile = $event"
                @import="importFile($event)"></upload-modal>
    </div>
</template>

<script>
import {useI18n} from "vue-i18n";
import Modal from "@/components/modal";
import Clients from '@/services/Clients';
import {useToast} from "vue-toastification";
import Validate from '@/components/validate.vue';
import viewClient from "./viewClientComponent.vue";
import createClient from "./createClientComponent.vue";
import pageHeader from "@/components/layouts/pageHeader";
import ListComponent from "@/components/layouts/listComponent.vue";
import PaginationComponent from "@/components/layouts/PaginationComponent";
import jwt_decode from "jwt-decode";
import uploadModal from "@/components/layouts/uploadModal";
import Drive from "../../services/Drive";
import Select2 from 'vue3-select2-component';
import {mapState} from 'vuex';
import widthMd from '../../mixins/widthMd';
import AttibutesValidations from '../../services/AttibutesValidations';
import {PDFDocument} from 'pdf-lib';
import moment from 'moment';
import Dashboard from '../../services/Dashboard';
import Public from '../../services/Public';

export default {
    name: 'indexClient',
    mixins: [Validate, widthMd],
    components: {
        Modal,
        pageHeader,
        viewClient,
        createClient,
        ListComponent,
        PaginationComponent,
        uploadModal,
        Select2,
    },
    computed: {
        ...mapState({
            paginate: 'paginate',
            allotmentsBackup: 'allotmentsOnlyUserAllo',
            allotmentsState: 'allotments',
        })
    },
    watch: {
        allotmentsBackup() {
            this.allotments = this.allotmentsBackup
        }
    },
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    data() {
        return {
            searchI: null,
            filterExport: {},
            allotmentAux: [],
            allotments: [],
            allotmentModal: '',
            isPhisical: true,
            documents: [],
            items: null,
            client: null,
            filters: {},
            file: [],
            fileDescription: null,
            perPage: null,
            clientUploadDocument: null,
            filter: null,
            number: "",
            address: null,
            wichModal: null,
            nameOfCreator: "",
            uploadFile: false,
            modalTitle: null,
            clientPublic: window.location.host,
            isAnex: null,
            peopleQtd: 0,
        }
    },
    mounted() {
        this.$canAccess('Client_index');
        if (this.$hasPermission('group_adm')) this.getQtdPeople();
        this.index();
    },
    methods: {
        clearFilters()
        {
            this.filters = {};
            this.index(this.filter);
        },
        filtering(){
            this.index(this.filter);
        },
        sheckAdmin() {
            let companies = jwt_decode(localStorage.getItem('access_token'))
                    .roles['companies'];
            companies.forEach(company => {
                company.companies.forEach(id => {
                    if (localStorage.getItem('companyId') === id) {
                        this.isAdmin = company.group_id;
                    }
                })
            })
        },
        getQtdPeople() {
            Dashboard.getQtdPeople(localStorage.getItem('companyId')).then((resp) => {
                this.peopleQtd = resp.data?.people?.total;
            })
        },
        emitWithEnter(log) {
            if (log.key == 'Enter') {
                this.search(this.searchI);
            }
        },
        sendExport() {
            if (this.filterExport?.created_at_start && this.filterExport?.created_at_end) {
                let date1 = moment(this.filterExport.created_at_start)
                if (date1.isAfter(moment(this.filterExport.created_at_end))) {
                    let aux = this.filterExport.created_at_start;
                    this.filterExport.created_at_start = this.filterExport.created_at_end;
                    this.filterExport.created_at_end = aux;
                }
            }
            this.$store.commit('changeLoading', true);
            Clients.exportFile(this.filterExport).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'pessoas.xlsx');
                link.click();
                this.modalTitle = '';
                this.wichModal = null;
                this.filterExport = {};
                document.getElementById('closeX')?.click();
                this.$store.commit('changeLoading', false);
            }).catch(() => this.$store.commit('changeLoading', false));
        },
        exportClient() {
            this.modalTitle = 'Filtros';
            this.wichModal = 5;
        },
        selectAllotmentModal() {
            this.allotmentAux = [];
            this.allotments = this.allotmentsBackup;
            this.allotments.forEach(company => {

                const text = company.text.toUpperCase();
                const textModal = this.allotmentModal.toUpperCase();

                if (text.includes(textModal)) {
                    this.allotmentAux.push(company);
                }
            })
            this.allotments = this.allotmentAux;
        },
        closeModal() {
            this.wichModal = null;
        },
        changePaginate(perPage) {
            this.perPage = perPage;
            this.index(this.filter, 1);
        },
        async getAttributesValidations(context) {
            this.$store.commit('changeLoading', true);
            await AttibutesValidations.getByContext(context).then(resp => {
                this.$store.commit('setItemsValidations', resp.data);
                this.$store.commit('changeLoading', false);
            }).catch(() => {
                this.$store.commit('changeLoading', false);
            });
        },
        closeModalAnex() {
            document.getElementById('closeX').click();
        },
        documentDelete(id) {
            this.$store.commit('changeLoading', true);
            Drive.fileDelete(id).then(() => {
                this.documents = this.documents.filter(document => {
                    if (document.id !== id) return document;
                })
                this.toast.success(this.t('CLIENTS.DOCUMENTS.DELETE_SUCCESSFULL'));
                this.$store.commit('changeLoading', false);
            }).catch(err => {
                this.errorMsg(err);
                this.$store.commit('changeLoading', false);
            });
        },
        formatSize(fileSize) {
            if (fileSize < 1000) return `${fileSize} Bytes`
            if (fileSize > 1000 && fileSize < 1000000) return `${(fileSize / 1000).toFixed()} KB`
            if (fileSize >= 1000000 && fileSize < 1000000000) return `${(fileSize / 1000000).toFixed(2)} MB`
            if (fileSize >= 1000000000) return `${(fileSize / 1000000000).toFixed(2)} GB`
        },
        downloadDocument(doc) {
            this.$store.commit('changeLoading', true);
            Drive.download(doc.id).then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', doc.name);
                link.click();
                this.$store.commit('changeLoading', false);
            }).catch(() => this.$store.commit('changeLoading', false));
        },
        setSendDocumentModal(id) {
            this.$store.commit('changeLoading', true);
            Clients.show(id).then((resp) => {
                this.documents = resp.data.documents;
                this.$store.commit('changeLoading', false);
            }).catch(() => {
                this.documents = [];
                this.$store.commit('changeLoading', false);
            });
            this.clientUploadDocument = id;
            this.modalTitle = this.t('ACTIONS.ATTACH_DOCUMENT');
            this.wichModal = 3;
        },
        async printClientPdf(iten) {
            this.$store.commit('changeLoading', true);
            await Clients.exportPdfClient(iten.id).then(async (response) => {
                if (response.data?.length) {
                    const mergedPdf = await PDFDocument.create();
                    for (const pdfObj of response.data) {
                        if (pdfObj?.basefile) {
                            const pdfBase64 = pdfObj.basefile;
                            const pdfBytes = this.base64ToUint8Array(pdfBase64);
                            try {
                                const pdfDoc = await PDFDocument.load(pdfBytes);
                                const copiedPages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
                                copiedPages.forEach((page) => mergedPdf.addPage(page));
                            } catch (err) {
                                const blob = new Blob([pdfBytes], {type: 'application/pdf'});
                                const url = URL.createObjectURL(blob);
                                const a = document.createElement('a');
                                a.href = url;
                                let fileName = response.data.find(i => i)?.name ? response.data.find(i => i)?.name : 'arquivoPessoas.pdf';
                                fileName = fileName?.replaceAll('.pdf', '');
                                fileName = fileName + (pdfObj?.name ? pdfObj?.name : '.pdf');
                                a.download = fileName;
                                document.body.appendChild(a);
                                a.click();
                                document.body.removeChild(a);
                                URL.revokeObjectURL(url);
                            }
                        }
                    }

                    const mergedPdfFile = await mergedPdf.save();
                    const blob = new Blob([mergedPdfFile], {type: 'application/pdf'});
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    let fileName = response.data.find(i => i)?.name ? response.data.find(i => i)?.name : 'arquivoPessoas.pdf'
                    a.href = url;
                    a.download = fileName;
                    a.style.display = 'none';
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                }
                this.$store.commit('changeLoading', false);
            }).catch((err) => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(err);
            })
        },
        base64ToUint8Array(base64) {
            const base64Data = base64.replace(/^data:application\/pdf;base64,/, '');
            const binaryString = window.atob(base64Data);
            const len = binaryString.length;
            const bytes = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            return bytes;
        },
        chooseFile(e) {
            let filename = ''
            let targetFiles = e.target.files;
            for (let file of targetFiles) {
                filename = filename + file.name + '; '
            }
            this.file = {'fileName': filename, ...targetFiles}
        },
        uploadDocument(file) {
            if (!file) return this.toast.error(this.t('CLIENTS.DOCUMENTS.FILE_EMPTY'));
            this.$store.commit('changeLoading', true);
            let formData = new FormData();
            formData.append('file', file);
            formData.append('context_id', this.clientUploadDocument);
            formData.append('context', 'clientes');
            Drive.uploadDocument(formData).then((resp) => {
                if (resp.data.code) {
                    this.toast.success(resp.data.description);
                } else {
                    this.toast.success(this.t('CLIENTS.DOCUMENTS.CREATED'));
                }
                this.documents.push(resp.data);
                this.$store.commit('changeLoading', false);
            }).catch(err => {
                this.errorMsg(err);
                this.$store.commit('changeLoading', false);
            }).finally(() => {
                this.$store.commit('changeLoading', false)
            })
        },

        setFile() {
            this.uploadFile = true;
            this.isAnex = true;
        },
        index(filter = null, page = 1) {
            this.$store.commit('changeLoading', true);
            Clients.index(page, filter, this.perPage, this.filters).then(resp => {
                this.items = resp.data;
                this.$store.commit('changeLoading', false);
            }).catch(error => {
                this.errorMsg(error);
                this.$store.commit('changeLoading', false);
            });
        },
        open(client) {
            client.open = !client.open ? true : false;
        },
        importFile(file) {
            if (this.isAnex) {
                this.uploadDocument(file)
                return;
            }
            this.$store.commit('changeLoading', true);
            Clients.importFile(file).then(async () => {
                await this.index();
                this.toast.success(this.t('CLIENTS.CLIENT_IMPORT_WITH_SUCCESSS'));
                this.uploadFile = false;
                this.$store.commit('changeLoading', false);
            }).catch((err) => {
                this.errorMsg(err);
                this.uploadFile = false;
                this.$store.commit('changeLoading', false);
            });
        },
        setModalFilter() {
            this.wichModal = 6;
            this.modalTitle = "ACTIONS.FILTERS";
        },
        setModalCopyLink() {
            this.allotments = this.allotmentsBackup;
            let div = document.createElement('div');
            div.setAttribute('data-toggle', 'modal');
            div.setAttribute('data-target', '#customModalTwo');
            let body = document.getElementsByTagName('body')[0];
            body.appendChild(div);
            setTimeout(function () {
                div.click();
                div.remove();
            }, 100);
            this.wichModal = 4;
            this.modalTitle = "Selecione um loteamento";
        },
        async copyLink(allotmentId) {
            this.$store.commit('changeLoading', true)
            await Public.getUuidUserByExtenalId(jwt_decode(localStorage.getItem('access_token')).idUsuario)
                    .then(async resp => {
                        let userId = resp.data;
                        let link;
                        if (allotmentId === 'nenhum') {
                            link = window.location.protocol + '//' + this.clientPublic + '/cliente-publico/' + localStorage.getItem('companyId') + '/' + userId;
                        } else {
                            link = window.location.protocol + `//${this.clientPublic}/cliente-publico/${localStorage.getItem('companyId')}/${userId}/${allotmentId}`;
                        }
                        await Public.getLinkCut(link).then(resp => {
                            this.$store.commit('changeLoading', false);
                            navigator.clipboard.writeText(resp.data.link).then(() => {
                                this.toast.success("Link de acesso ao cadastro de clientes na área pública foi copiado sucesso");
                            });
                            document.getElementById('closeX').click();
                        }).catch(() => this.$store.commit('changeLoading', false))
                    }).catch(() => this.$store.commit('changeLoading', false));
        },
        async setRegisterModal(type) {
            if (type === 'juridical') {
                this.isPhisical = false;
                await this.getAttributesValidations('clients_juridical');
            } else {
                this.isPhisical = true;
                await this.getAttributesValidations('clients_phisical');
            }
            this.client = {
                rg: null,
                name: null,
                phones: [],
                email: null,
                taxpayer: null,
                mother_name: null,
                father_name: null,
                sex: null,
                nationality: type === 'juridical' ? null : 'Brasileiro(a)',
                description: null,
                created_by: null,
                profession_id: null,
                marital_status_id: null,
                naturalness: null,
                dispatch_date: null,
                marital_status: null,
                dispatching_agency: null
            };
            this.address = {
                cep: null,
                street: null,
                number: null,
                complement: null,
                neighborhood: null
            };
            this.wichModal = 1;
            this.modalTitle = 'CLIENTS.MODAL_TITLE.ADD';
        },

        switchToEdit(id) {
            if (this.$hasPermission('Client_update')) {
                this.toast.success(this.t("GENERAL.MSG.CLIENT_ALREADY_IN_COMPANY"));
                this.wichModal = 1;
                this.showClient(id);
                this.modalTitle = 'CLIENTS.MODAL_TITLE.EDIT';
                this.$store.commit('changeLoading', false)
            }
        },

        async setEditModal(id) {
            this.$store.commit('changeLoading', true);
            await this.showClient(id, true);
            this.modalTitle = 'CLIENTS.MODAL_TITLE.EDIT';
            this.wichModal = 1;
            await this.$nextTick();
        },

        async showClient(id, edit = false) {
            await Clients.show(id).then(async resp => {
                this.client = resp.data;
                this.client.income = this.client.income ? parseFloat(this.client.income).toFixed(2) : null;
                this.client.income_family = this.client.income_family ? parseFloat(this.client.income_family).toFixed(2) : null;
                this.client.dispatch_date = resp.data.dispatch_date;
                if (resp.data.address) {
                    this.address = resp.data.address;
                } else {
                    this.address = {
                        cep: null,
                        street: null,
                        number: null,
                        neighborhood: null,
                        complement: null,
                        city_id: null,
                    }
                }
                if (edit) {
                    if (this.client?.taxpayer?.length <= 14) {
                        await this.getAttributesValidations('clients_phisical');
                    } else {
                        await this.getAttributesValidations('clients_juridical');
                    }
                }
                this.$store.commit('changeLoading', false);
            }).catch(error => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(error)
            });
        },

        setViewModal(id) {
            this.$store.commit('changeLoading', true);
            this.wichModal = 2;
            this.showClient(id);
            this.modalTitle = 'CLIENTS.MODAL_TITLE.VIEW';
        },

        showAlert(id) {
            this.$swal.fire({
                title: this.t('GENERAL.MSG.REALLY_WANT_DELETE'),

                showCancelButton: true,
                showCloseButton: true,
                confirmButtonText: `Excluir`,
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store.commit('changeLoading', true);
                    Clients.delete(id).then(() => {
                        this.index();
                        document.getElementById('closeX').click();
                        this.toast.success(this.t('GENERAL.MSG.DELETED_SUCCESS'));
                        this.$store.commit('changeLoading', false);
                    }).catch(error => {
                        this.toast.error(this.t('GENERAL.MSG.DELETE_NOT_PERFORMED_BECAUSE_DEPENDENCY'), {timeout: false});
                        this.$store.commit('changeLoading', false);
                        this.errorMsg(error)
                    });
                }
            });
        },

        phoneNumber(client) {
            if (client.phones.length > 1) {
                let tel = client.phones;
                switch (client.phones.length) {
                    case 2:
                        return `${tel[0].number}/${tel[1].number}`;
                    case 3:
                        return `${tel[0].number}/${tel[1].number}/${tel[2].number}`;
                }
                return `${tel[0].number} - AVISO: ${this.t('GENERAL.MSG.ACCESS_OTHER_PHONE_NUMBERS')}`
            }
            return client.phones[0]?.number;
        },

        phoneNumberToCell(client) {
            if (client.phones.length > 1) {
                let tel = client.phones;
                switch (client.phones.length) {
                    case 2:
                        return `${tel[0]?.number}/${tel[1]?.number}`;
                }
                return `${tel[0]?.number} - AVISO: ${this.t('GENERAL.MSG.ACCESS_OTHER_PHONE_NUMBERS')}`
            }
            return client.phones[0]?.number;
        },

        search(filter) {
            this.filter = {filtro: filter};
            this.index(this.filter, 1);
        }
    }
}
</script>

<style>
.color-grey {
    color: #727272;
}

.font-seven {
    font-size: 0.7rem !important;
}

.client-allotment-body {
    --client-allotment-panel: #ffffff;
    --client-allotment-panel-soft: #f8fafc;
    --client-allotment-border: #e2e8f0;
    --client-allotment-text: #0f172a;
    --client-allotment-muted: #64748b;
    --client-allotment-primary: #0e5e4e;
    padding: 1.5rem 1.5rem 0 !important;
    overflow-x: hidden;
}

.client-allotment-search-label {
    margin-bottom: 0.45rem;
    color: var(--client-allotment-muted);
    font-size: 0.78rem;
    font-weight: 800;
}

.client-allotment-search-input {
    height: 48px;
    margin-bottom: 1rem;
    border: 1px solid var(--client-allotment-border);
    background: var(--client-allotment-panel-soft);
    color: var(--client-allotment-text);
    box-shadow: none;
}

.client-allotment-search-input:focus {
    border-color: var(--client-allotment-primary);
    box-shadow: 0 0 0 0.2rem rgba(14, 94, 78, 0.12);
}

.client-allotment-list {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 0.65rem;
    max-height: 48vh;
    max-width: 100%;
    padding-right: 0.25rem;
    overflow-x: hidden;
}

.client-allotment-list-item {
    min-width: 0;
    max-width: 100%;
}

.client-allotment-option-button {
    width: 100%;
    max-width: 100%;
    min-height: 58px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.85rem;
    padding: 0.75rem 0.9rem;
    border: 1px solid var(--client-allotment-border);
    background: var(--client-allotment-panel);
    color: var(--client-allotment-text);
    text-align: left;
    font-weight: 700;
    transition: transform .16s ease, border-color .16s ease, background-color .16s ease, box-shadow .16s ease;
}

.client-allotment-option-button:hover,
.client-allotment-option-button:focus {
    transform: translateY(-1px);
    border-color: rgba(14, 94, 78, 0.35);
    background: var(--client-allotment-panel-soft);
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
    color: var(--client-allotment-text);
}

.client-allotment-option-avatar {
    width: 36px;
    height: 36px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 36px;
    background: rgba(14, 94, 78, 0.12);
    color: var(--client-allotment-primary);
    font-weight: 900;
    text-transform: uppercase;
}

.client-allotment-option-name {
    flex: 1;
    min-width: 0;
    overflow-wrap: anywhere;
    white-space: normal;
    word-break: break-word;
}

.client-allotment-option-icon {
    flex: 0 0 auto;
    color: var(--client-allotment-muted);
    font-size: 1.35rem;
}

.client-allotment-empty-state {
    padding: 1.35rem;
    border: 1px dashed var(--client-allotment-border);
    color: var(--client-allotment-muted);
    text-align: center;
    font-weight: 700;
}

@media (max-width: 575.98px) {
    .client-allotment-body {
        padding: 1rem 1rem 0 !important;
    }

    .client-allotment-option-button {
        align-items: flex-start;
        gap: 0.65rem;
        padding: 0.75rem;
    }

    .client-allotment-option-name {
        flex-basis: calc(100% - 48px);
    }

    .client-allotment-option-icon {
        margin-left: auto;
    }
}
</style>
